jQuery(function($) {
	if (!$('.events_carousel .slider_wrapper').length)
		return;

	$('.events_carousel .slider_wrapper').on('init', function(event){
		$('.events_carousel .slick-arrow').on('click', function() {
			setTimeout(function(){
				currentSlideEl = $('.events_carousel .slider .slick-active');
				currentSlideEl.find('.event_title a').focus();
			}, 300);
		});
	});

	initializeSlick('.events_carousel .slider_wrapper', {
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplay: false,
		arrows: true,
		nextArrow: '<button class="slider_arrow next_arrow" aria-label="Next event">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow" aria-label="Previous event">Previous</button>',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
		]
	});
});